module.exports = __webpack_public_path__ + "static/media/romanacorreale-stargem-01.f4eb691b.png";